<div class="main-layout">
    <mat-toolbar class="syn--do-not-print main mat-elevation-z0">
        <mat-toolbar-row class="main">

            <!--Logo-->
            <div class="left" fxLayoutAlign="center center">
                <button mat-icon-button (click)="mainSlideNav.toggle()">
                    <mat-icon svgIcon="menu"></mat-icon>
                </button>
                <a routerLink="/" class="logo" *ngIf="!mobileQuery.matches">
                    <img src="assets/img/logo/logo-synapps-white.svg" />
                </a>
            </div>

            <div class="right">
                <!-- Global search -->
                <div class="global-search-wrapper" [style.border-radius]="'21px'">
                    <form [formGroup]="globalSearchForm" (ngSubmit)="doSearch()">
                        <button mat-icon-button type="submit" class="no-hover" [style.padding]="'0px'" [style.height]="'40px'" [style.width]="'40px'">
                            <mat-icon svgIcon="magnify"></mat-icon>
                        </button>

                        <input type="text" placeholder="Recherche globale" formControlName="term"/>
                    </form>
                </div>

                <syn-notification></syn-notification>

                <!--User Menu-->
                <div class="user-menu" *ngIf="account">
                    <mat-menu #userMenu="matMenu">
                        <button mat-menu-item routerLink="/users/{{ account.id }}">Mon compte</button>
                        <a mat-menu-item target="_blank" [href]="accountSecurityGroupsUrl">
                            Mes groupes de sécurité
                            <mat-icon class="externalLinkIcon" svgIcon="open-in-new"></mat-icon>
                        </a>
                        <a mat-menu-item target="_blank" [href]="account.resetPasswordUrl">
                            Changer mon mot de passe
                            <mat-icon class="externalLinkIcon" svgIcon="open-in-new"></mat-icon>
                        </a>
                        <button mat-menu-item routerLink="/users/tokens/list">Gérer mes tokens</button>
                        <button mat-menu-item (click)="logout()">Déconnexion</button>
                    </mat-menu>
                    <button mat-icon-button [matMenuTriggerFor]="userMenu">
                        <syn-user-avatar
                            [user]="account"
                            [clickable]="false"
                        ></syn-user-avatar>
                    </button>
                </div>
            </div>

        </mat-toolbar-row>

        <mat-toolbar-row class="progress-bar" [ngClass]="{'progress-bar-preprod': isNotProduction}"></mat-toolbar-row>

    </mat-toolbar>

    <mat-sidenav-container class="main-sidenav-container" [hasBackdrop]="tabletQuery.matches">
        <mat-sidenav #mainSlideNav class="syn--do-not-print main mat-elevation-z0" [mode]="tabletQuery.matches ? 'over' : 'side'" [opened]="!tabletQuery.matches">

            <!--Side menu-->
            <nav fxFlex fxLayout="column" fxLayoutAlign="space-between">
                <div>
                    <a *ngIf="canRead.tribe && canRead.cell"
                        routerLink="/organizations"
                        [routerLinkActive]="['sidenav__link--current']"
                        matTooltip="Organisation"
                        matTooltipPosition="right"
                    >
                        <div></div>
                        <mat-icon svgIcon="account-group-outline"></mat-icon>
                    </a>
                    <a *ngIf="canRead['business-project']"
                        routerLink="/business-projects"
                        [routerLinkActive]="['sidenav__link--current']"
                        matTooltip="Business projects"
                        matTooltipPosition="right"
                    >
                        <div></div>
                        <mat-icon svgIcon="briefcase-variant-outline"></mat-icon>
                    </a>
                    <a *ngIf="canRead.companies"
                        routerLink="/companies"
                        [routerLinkActive]="['sidenav__link--current']"
                        matTooltip="Sociétés"
                        matTooltipPosition="right"
                    >
                        <div></div>
                        <mat-icon svgIcon="domain"></mat-icon>
                    </a>
                    <a *ngIf="canRead.projects"
                    routerLink="/projects"
                    [routerLinkActive]="['sidenav__link--current']"
                    matTooltip="Projets"
                    matTooltipPosition="right"
                    >
                        <div></div>
                        <mat-icon svgIcon="folder-outline"></mat-icon>
                    </a>
                    <a *ngIf="canRead.inventory"
                    routerLink="/inventory"
                    [routerLinkActive]="['sidenav__link--current']"
                    matTooltip="Inventaires"
                    matTooltipPosition="right"
                    >
                        <div></div>
                        <mat-icon svgIcon="dns-outline"></mat-icon>
                    </a>
                    <a *ngIf="canRead.users"
                    routerLink="/users"
                    [routerLinkActive]="['sidenav__link--current']"
                    matTooltip="Utilisateurs"
                    matTooltipPosition="right"
                    >
                        <div></div>
                        <mat-icon svgIcon="account-outline"></mat-icon>
                    </a>
                    <a *ngIf="canRead.tickets"
                    [href]="oneViewUrl"
                    target="_blank"
                    [routerLinkActive]="['sidenav__link--current']"
                    matTooltip="Tickets"
                    matTooltipPosition="right"
                    >
                        <div></div>
                        <mat-icon svgIcon="bug-outline"></mat-icon>
                    </a>
                    <a *ngIf="canRead.app"
                        routerLink="/apps"
                        [routerLinkActive]="['sidenav__link--current']"
                        matTooltip="Apps"
                        matTooltipPosition="right"
                    >
                        <div></div>
                        <mat-icon svgIcon="application-braces-outline"></mat-icon>
                    </a>
                </div>
                <div>
                    <a [matMenuTriggerFor]="resourcesMenu" class="syn--clickable"
                        matTooltip="Aide"
                        matTooltipPosition="right"
                    >
                        <mat-icon svgIcon="help-circle-outline"></mat-icon>
                    </a>
                    <mat-menu #resourcesMenu="matMenu">
                        <a mat-menu-item routerLink="/inventory/schemas">
                            <mat-icon svgIcon="dns-outline"></mat-icon>
                            <span>Modèles d'inventaire</span>
                        </a>
                        <a mat-menu-item href="https://claranet-fr.atlassian.net/jira/plans/15/scenarios/15/timeline" target="_blank">
                            <mat-icon svgIcon="map"></mat-icon>
                            <span>Roadmap</span>
                        </a>
                        <a mat-menu-item [href]="docUrl" target="_blank">
                            <mat-icon svgIcon="file"></mat-icon>
                            <span>Documentation API</span>
                        </a>
                    </mat-menu>
                </div>
            </nav>
        </mat-sidenav>
        <mat-sidenav-content id="scroll-container" [ngClass]="sidenavContentClass">

            <!--Main content-->
            <div [ngClass]="containerClass">
                <router-outlet></router-outlet>
            </div>

        </mat-sidenav-content>
    </mat-sidenav-container>

    <syn-drawer></syn-drawer>
</div>
<!-- VERSION {{version}} -->
